<div [ngClass]="positionFixed ? 'footer-fixed' : 'footer-nonFixed'" class="footer">
    <div class="footer-inner">
        <p class="footer-text">
            Any questions regarding the letter and or information being requested, please refer to the contact
            information within the letter and reach out to the appropriate party.
        </p>
        <p class="footer-text">
            For questions or issues with this website, please contact
            <a href="mailto:filecapturesupport@gainwelltechnologies.com" class="footer-link">filecapturesupport@gainwelltechnologies.com</a>
            and include the Reference ID from the letter received.
        </p>
        <div class="footer-links">
            <a href="https://www.gainwelltechnologies.com/terms-of-use/" target="_blank" class="footer-nav-link">Terms of Use</a>
            <span class="footer-sep">|</span>
            <a href="https://www.gainwelltechnologies.com/privacy/" target="_blank" class="footer-nav-link">Privacy Policy</a>
            <span class="footer-sep">|</span>
            <a href="https://www.gainwelltechnologies.com/cookies-policy/" target="_blank" class="footer-nav-link">Cookie Policy</a>
        </div>
    </div>
</div>